import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Subject, Observable, BehaviorSubject, forkJoin } from 'rxjs';
// tslint:disable-next-line:import-blacklist
import * as Rx from 'rxjs';


const headers = new HttpHeaders({
  'Content-Type': 'application/json; charset=utf-8',
  'Access-Control-Allow-Origin': '*', 'Access-Control-Allow-Credentials': 'true',
  'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS'
});



@Injectable()
export class AccountService {
 
 



  accountStatusFilter: any;
  paymentTabindex: any;
  paymentData: any;
  public acc_total_count = new BehaviorSubject<any>(0);
  createdFromDate: any;
  dateOperator: any;
  createdTodate: any;

  filterdata : any ;// i added -----------------------
  cloudSearchUrl: any;
  accountfilterdata: Observable<Object>;
 
  constructor(private http: HttpClient) { }
  accountData: any = {};
  analyticsInfo: any;

  getTaxDetailsUrl = '/superadmin/rest/mgmt/account/tax/settings';
  accountAnalyticsBySectorUrl = '/superadmin/rest/mgmt/analytics/accounts';
  accountActiveInactiveUrl = '/superadmin/rest/mgmt/analytics/accounts/sec/loc/count?';
  topTenActiveAccountUrl = '/superadmin/rest/mgmt/analytics?count=10&';
  transactionsUrl = '/superadmin/rest/mgmt/analytics/transactions/count';
  waitlistCountUrl = '/superadmin/rest/mgmt/analytics/waitlist/count?&';
  newlySignedUpAccountUrl = '/superadmin/rest/mgmt/analytics/accounts/sec/loc/date/count?';
  accountListUrl = '/superadmin/rest/mgmt/account?';
  countUrl = '/superadmin/rest/mgmt/account/count?';
  accountUrl = '/superadmin/rest/mgmt/account';
  accountcontactUrl = '/superadmin/rest/mgmt/account/contact';
  account_id_url = '/superadmin/rest/mgmt/account/uid';
  deleteAccountbyCriteria = '/superadmin/rest/mgmt/account?';
  deleteBranchbyCriteria = '/superadmin/rest/mgmt/corporate/branch?';
  licenseDetailsUrl = '/superadmin/rest/mgmt/account/licensedetails';
  paymentSettingsUrl = '/superadmin/rest/mgmt/account/payment/settings';
  advancePaymentSettingsUrl = '/superadmin/rest/mgmt/account/payment/advPayBank?accId=';
  advancePaymentupdateUrl = '/superadmin/rest/mgmt/account/payment/advPayBank';
  advancePayBankUrl = '/superadmin/rest/mgmt/account/payment/advancePayBank';
  invoiceListUrl = '/superadmin/rest/mgmt/account/license/invoice';
  proformainvoiceListUrl = '/superadmin/rest/mgmt/proformainvoice';
  paymentTransactionUrl = '/superadmin/rest/mgmt/payment/test';
  deleteAccountUrl = '/superadmin/rest/mgmt/account?id=';
  changeStatusUrl = '/superadmin/rest/mgmt/account/toggleStatus';
  changeRealStatusUrl = '/superadmin/rest/mgmt/account/prod';
  updateContactdataUrl = '/superadmin/rest/mgmt/account/contact';
  verifyUrl = '/superadmin/rest/mgmt/account/verify';
  licenseAuditUrl = '/superadmin/rest/mgmt/account/license/auditlog';
  addonAuditUrl = '/superadmin/rest/mgmt/account/license/addon/auditlog';
  addonmetaDataUrl = '/superadmin/rest/mgmt/account/license/addonmetadata';
  renewLicenseUrl = '/superadmin/rest/mgmt/account/license/renewal';
  licensepkgsUrl = '/superadmin/rest/mgmt/account/licensepackages';
  addAddonUrl = '/superadmin/rest/mgmt/account/license/addon/add';
  changeLicenseUrl = '/superadmin/rest/mgmt/account/license/change';
  // changeLicenseSubscriptionUrl = '/superadmin/rest/mgmt/account/license/changeSubscription/';
  // addonUrl = '/superadmin/rest/mgmt/account/license/addon/';
  addonUrl = '/superadmin/rest/mgmt/account/license';
  mergeinvoice = '/superadmin/rest/mgmt/account/license/invoice';
  copset = '/superadmin/rest/mgmt/account';
  testPayuUrl = '/superadmin/rest/mgmt/payment/payu';
  merchantUrl = '/superadmin/rest/mgmt/account/payment/settings';
  licenseInfoUrl = '/superadmin/rest/mgmt/account/license';
  paymentGatewayUrl = '/superadmin/rest/mgmt/account/payment/status/count';
  adwordUrl = '/superadmin/rest/mgmt/account/license/adwords';
  emailUnverifyUrl = '/superadmin/rest/mgmt/account/unverifyEmail';
  support_emailUnverifyUrl = '/superadmin/rest/support/account/unverifyEmail';
  getMinimalInfoUrl = '/superadmin/rest/mgmt/account/getMinimalInfo';
  accountPaymentUrl = '/superadmin/rest/mgmt/account/payment?';
  accountPaymentCountUrl = '/superadmin/rest/mgmt/account/payment/count?';
  accountChangePrimaryPhoneNo = '/superadmin/rest/mgmt/account/settings/changePrimaryPhone';
  markaspaidUrl = '/superadmin/rest/mgmt/account/license/invoice/acceptPayment';
  getCorporatesUrl = '/superadmin/rest/mgmt/corporate';
  // applyinvoicediscountUrl = '/superadmin/rest/mgmt/account/license/invoice/applyDiscount';
  applyinvoicediscountUrl = '/superadmin/rest/mgmt/account/license/invoice/disc';
  applyproformaInvoicediscountUrl = '/superadmin/rest/mgmt/proformainvoice';
  getPaidDetailsUrl = '/superadmin/rest/mgmt/account/payment';
  licenseMetricUrl = '/superadmin/rest/mgmt/account/license/metric';
  deleteUnclaimedAccountsbyCriteria = '/superadmin/rest/mgmt/account/unclaimed?';
  awsUrl = '/superadmin/rest/mgmt/login/cloudSearchUrl';
  gstURL = '/superadmin/rest/mgmt/ynwConf/jaldeeGst';
  accountLicenseInvoicesUrl = '/superadmin/rest/mgmt/account/license/invoice?';
  accountLicenseInvoiceCountUrl = '/superadmin/rest/mgmt/account/license/invoice/count?';
  cancelinvoiceUrl = '/superadmin/rest/mgmt/account/license/invoice';
  updateBusinessProfileUrl = '/superadmin/rest/mgmt/account/bProfile';
  updateServiceUrl = '/superadmin/rest/mgmt/account/service';
  updateSettingsUrl = '/superadmin/rest/mgmt/account/settings';
  uploadDataToCloudUrl = '/superadmin/rest/mgmt/account/search';
  licenseUsageInfoUrl = '/superadmin/rest/mgmt/account/license';
  paymentHistoryUrl = '/superadmin/rest/mgmt/account/license/invoice/payment/history';
  paymentHistoryCountUrl = '/superadmin/rest/mgmt/account/license/invoice/payment/history';
  paymentHistoryuuidUrl = '/superadmin/rest/mgmt/payment/details';
  VideoModeUrl = '/superadmin/rest/mgmt/account/settings';
  testRazorPayUrl = '/superadmin/rest/mgmt/payment/razorpay';
  testRazorPayUrlUpdate = '/superadmin/rest/mgmt/payment/razorpay/update';
  testRazorPaySuccessUrl='/superadmin/rest/mgmt/payment/razorpaysuccess';
  bookingStatUrl='/superadmin/rest/mgmt/booking';
  getSupportUrl='/superadmin/rest/mgmt/user/saUserTypeNme';
  questionnaireUrl = '/superadmin/rest/mgmt/b2b';
  sendmsgbyId = '/superadmin/rest/mgmt/account/providerMassCommunicationWithId';
  sendmsg = '/superadmin/rest/mgmt/account/providerMassCommunication?';
  bookingStatspCountUrl = '/superadmin/rest/mgmt/booking';
  LabelgetUrl = '/superadmin/rest/mgmt/account/getlabel';
  ApplyLabelUrl = '/superadmin/rest/mgmt/account/labelBatch';
  DeleteLabelUrl = '/superadmin/rest/mgmt/account/masslabel';
  getSpByOfferUrl = '/superadmin/rest/mgmt/jcash/offer/stat';
  paymentDetailsUrl = '/superadmin/rest/mgmt/payment/settings/bankInfo';
  paymentProfilesUrl = '/superadmin/rest/mgmt/account/payment/paymentProfiles';
  defaultPayBankUrl = '/superadmin/rest/mgmt/account/payment/defaultPayBank';
  payBankDetailsUrl = '/superadmin/rest/mgmt/account/payment/payBankDetails';
  publishinvoiceUrl = '/superadmin/rest/mgmt/account/license/invoice/publish';
  testPaytmUrl = '/superadmin/rest/mgmt/payment/paytm';
  getPresignedPWAUrl = '/superadmin/rest/mgmt/account/preSign';
  paymentSettlementUrl = '/superadmin/rest/mgmt/payment/settlement';
  analyticsUrl = "/superadmin/rest/mgmt/analytics";
  jaldeeHomeoUrl = '/superadmin/rest/mgmt/account';
  channelsUrl = '/superadmin/rest/mgmt/account/serviceConfig';
  changestatementGenerationUrl = '/superadmin/rest/mgmt/account/license/createBySystem';
  noteUrl = '/superadmin/rest/mgmt/payment';
  sectionListUrl = '/superadmin/rest/mgmt/provider/medicalrecord/section/templatedetail';
  sectionUrl = '/superadmin/rest/mgmt/provider/medicalrecord/section/template';
  migrationUrl = '/superadmin/rest/mgmt/spdataimport/account';
  exportUrl = '/superadmin/rest/mgmt/spdataexport/account';
  consentFormUrl = '/superadmin/rest/mgmt/consentform';
  invoiceUrl = '/superadmin/rest/mgmt/account/license/invoice/markAsNotPaid';
  public params: Subject<any> = new Subject<any>();
  consumerData: {};

  
  
  
  licenseFilter: any;
  categoryFilter: any;
  agentFilter: any;
  domainFilter: any;
  userAgentFilter: any;
  // AnalyticsInfo:any;



  public next(params): void { this.params.next(params); }

  getActiveInactiveAccountCount(sector,filterparams): Observable<any> {
    const activeAccountCount = this.http.get(this.countUrl + filterparams + '&accntStatus-eq=active');
    const inactiveAccountCount = this.http.get(this.countUrl + filterparams + '&accntStatus-eq=inactive');
    return forkJoin([activeAccountCount, inactiveAccountCount]);
      // .map(responses => {
      //   return [].concat(...responses);
      // });
  }

  getTopTenAccountSummary(filterparams): Observable<any> {

    const waitlist = this.http.get(this.waitlistCountUrl + filterparams);
    const signedup = this.http.get(this.newlySignedUpAccountUrl + filterparams);
    return forkJoin([signedup, waitlist]);
      // .map(responses => {
      //   return [].concat(...responses);
      // });
  }

  getLicenseMetricData() {
    return this.http.get(this.licenseMetricUrl);
  }
  getTopTenAccount(filterparam) {
    return this.http.get(this.topTenActiveAccountUrl + filterparam, { headers: headers });
  }
  getAccountDetailsById(accountId) {
    return this.http.get(this.accountUrl +'/' + accountId, { headers: headers });

  }

  getAccountID(account_uid): Observable<any> {
    return this.http.get(this.account_id_url +'/'+ account_uid, { headers: headers });
  }
  storeAccountData(data) {
    this.accountData = {};
    this.accountData = data;

  }

//  getfilterdata():Observable<any>
//   { 
//     this.AnalyticsInfo = this.analyticsInfo;
//     return Observable.of(this.AnalyticsInfo);
//   }

  getCloudSearchUrlFromREST() {
    return this.http.get(this.awsUrl , { headers: headers });
  }
  getCloudSearchUrl() {
    return this.cloudSearchUrl;
  }
  setCloudSearchUrl(url) {
    this.cloudSearchUrl = url;

  }
  getGSTNumber() {
    return this.http.get(this.gstURL , { headers: headers });
  }
  retriveAccountData() {
    return this.accountData;
  }
  getCount(): Observable<any> {
    return this.http.get(this.countUrl, { headers: headers });
  }
  getTotalFilterCount(filter): Observable<any> {
    return this.http.get(this.countUrl + filter, { headers: headers });
  }
  getcommonTotalFilterCount(filter,label): Observable<any> {
    if(label){
      return this.http.get(this.countUrl + filter + 'label-eq=' + label + '::true', { headers: headers });
    }
    else{
      return this.http.get(this.countUrl + filter, { headers: headers });
    }
  }

  setLicenseFilterValue(data) {
    this.licenseFilter = data;
  }
  getLicenseFilterValue() {
    return this.licenseFilter;

  }
  setAccountStatusFilter(data) {
    this.accountStatusFilter = data;
  }
  getAccountStatusFilter() {
    return this.accountStatusFilter;
  }
  setCategoryFilterValue(data) {
    this.categoryFilter = data;
    // alert(this.categoryFilter)
  }
  getCategoryFilterValue() {
    return this.categoryFilter;
  }
  getAgentFilterValue() {
    return this.userAgentFilter;
  }
  setDomainFilterValue(data) {
    this.domainFilter = data;
   
  }
  setUserAgentFilterParam(data) {
    this.userAgentFilter = data;
  }
  setCreatedOperator(operator) {
    this.dateOperator = operator;

  }
  getCreatedOperator() {
    return this.dateOperator;

  }
  setCreatedFromDate(fromdate) {
    this.createdFromDate = fromdate;

  }
  getCreatedFromDate() {
    return this.createdFromDate;

  }
  setCreatedToDate(todate) {
    this.createdTodate = todate;
  }
  getCreatedToDate(todate) {
    return this.createdTodate;
  }
  getDomainFilterValue() {
    return this.domainFilter;
  }
  setPaymentData(data) {
    this.paymentData = data;
  }
  getPaymentData() {
    return this.paymentData;
  }

  getAccountsDatas(
    filter, sortOrder,
    pageNumber, pageSize,label): Observable<any> {
      if(label){
        return this.http.get(this.accountListUrl + filter + 'label-eq=' + label + '::true', {
          params: new HttpParams()
            .set('asc', sortOrder)
            .set('from', pageNumber.toString())
            .set('count', pageSize.toString())
        });
      }
      else{
        return this.http.get(this.accountListUrl + filter, {
          params: new HttpParams()
            .set('asc', sortOrder)
            .set('from', pageNumber.toString())
            .set('count', pageSize.toString())
        });
      }
    
  }

  getAccountsData(
    filter, sortOrder,
    pageNumber, pageSize): Observable<any> {
    return this.http.get(this.accountListUrl + filter, {
      params: new HttpParams()
        .set('asc', sortOrder)
        .set('from', pageNumber.toString())
        .set('count', pageSize.toString())
    });
  }
  getAccountsData_byOffer(
    filter, sortOrder,
    pageNumber, pageSize): Observable<any> {
    return this.http.get(this.getSpByOfferUrl+'/' + filter, {
      params: new HttpParams()
        .set('asc', sortOrder)
        .set('from', pageNumber.toString())
        .set('count', pageSize.toString())
    });
  }
  // getspStat(
  //   filter): Observable<any> {
  //   return this.http.get(this.bookingStatspCountUrl + '/' + filter, {
  //     params: new HttpParams()
  //       // .set('asc', sortOrder)
  //       // .set('from', pageNumber.toString())
  //       // .set('count', pageSize.toString())
  //   });
  // }
  getspStat(filterparams){
    return this.http.get(this.bookingStatspCountUrl + '/' + filterparams, { headers: headers });
  }
  licenseDetails(lid) {
    return this.http.get(this.licenseDetailsUrl +'/' + lid, { headers: headers });
  }
  updateService(accountID) {
    return this.http.get(this.updateServiceUrl +'/' + accountID , { headers: headers});

  }
  updateBusinessProfile(accountID) {
    return this.http.get(this.updateBusinessProfileUrl +'/' + accountID , { headers: headers});

  }
  uploadDataToCloud(accountId) {
    return this.http.get(this.uploadDataToCloudUrl +'/' + accountId, {headers: headers});
  }
  uploadSettings(accountId) {
    return this.http.get(this.updateSettingsUrl +'/'+ accountId, {headers: headers});
  }
  paymentSettingDetails(pid) {
    return this.http.get(this.paymentSettingsUrl +'/' + pid, { headers: headers });
  }
  advanceSettingDetails(accountId) {
    return this.http.get(this.advancePaymentSettingsUrl + accountId, { headers: headers });
  }
  setadvanceSetting(advancePayment,accountId) {
    return this.http.put(this.advancePaymentupdateUrl +'/' + advancePayment + '?accId='+ accountId, { headers: headers });
  }
  updateAdvancePayBank(accountId, data) {
    return this.http.put(this.advancePayBankUrl + '?accountId=' + accountId, data, { headers: headers });
  }
  getInvoices(invoiceid, status) {
    return this.http.get(this.invoiceListUrl +'/' + invoiceid + '/' + status, { headers: headers });
  }
  getTestTransactionDetails(transcid) {
    return this.http.get(this.paymentTransactionUrl +'/' + transcid, { headers: headers });
  }
  deleteAccount(filter) {
    return this.http.delete(this.deleteAccountbyCriteria + filter, { headers: headers });
  }
  changeStatusAccount(accid) {
    return this.http.put(this.changeStatusUrl +'/' + accid, { headers: headers });
  }
  changeStatusRealAccount(accid,status) {
    return this.http.put(this.changeRealStatusUrl +'/' + accid + '/' + status, { headers: headers });
  }
  uploadQuestion(accid) {
    return this.http.put(this.questionnaireUrl +'/' + accid + '/questionnaire/upload', { headers: headers });
  }
  getLicenseAudits(licid) {
    return this.http.get(this.licenseAuditUrl +'/' + licid, { headers: headers });
  }
  getAddonAudits(accountId) {
    return this.http.get(this.addonAuditUrl +'/' + accountId, { headers: headers });
  }
  getupgradableAddons() {
    return this.http.get(this.addonmetaDataUrl, { headers: headers });
  }
  getupgradableAddonss(accountId) {
    return this.http.get(this.addonmetaDataUrl + '/' + accountId, { headers: headers });
  }
  renewLicense(data) {
    return this.http.put(this.renewLicenseUrl, data, { headers: headers });


  }
  getJDNDetails(accId) {
    return this.http.get(this.accountUrl +'/' + accId + '/jdn', {headers: headers});
  }
  getContactInfo(accId) {
    return this.http.get(this.accountcontactUrl +  '/' + accId , {headers: headers});
  }
  updateScontact(data, accId) {
    return this.http.put(this.updateContactdataUrl + '/' + accId , data, {headers: headers});
  }
  getLicensePackages() {
    return this.http.get(this.licensepkgsUrl, { headers: headers });
  }
  addAddons(data) {
    return this.http.post(this.addAddonUrl, data, { headers: headers });
  }
  updateLicense(data) {
    return this.http.put(this.changeLicenseUrl, data, { headers: headers });
  }
 
  getInvoice(uuid) {
    return this.http.get(this.invoiceListUrl +'/' + uuid, { headers: headers });
  }
   getProformaInvoice(uuid) {
    return this.http.get(this.proformainvoiceListUrl +'/' + uuid, { headers: headers });
  }
  verifyPaytm(id) {
    return this.http.post(this.testPaytmUrl +'/' + id, { headers: headers });

  }
  testPayU(id) {
    return this.http.post(this.testPayuUrl +'/'+ id, { headers: headers });
  }
  testRazorPay(id){
    return this.http.post(this.testRazorPayUrl +'/' + id, { headers: headers });
  }
  deleteAddon(accountId, addonId) {
    return this.http.delete(this.addonUrl+'/' + accountId + '/licAddonId/' + addonId, { headers: headers });
  }

  setmerchantId(data) {
    return this.http.put(this.merchantUrl, data, { headers: headers });
  }
  setRazorpayMerchantDetails(data){
    // console.log('submittinh');
    return this.http.put(this.testRazorPayUrl +'/', data, { headers: headers });
  }
   updateRazorPay(data,account_id){
     const url=this.testRazorPayUrlUpdate+'?account='+account_id;
    return this.http.post(this.testRazorPayUrlUpdate, data, { headers: headers });
   }
   updatePaytm(data,account_id){
    const url=this.testPaytmUrl+'/update?account='+account_id;
    return this.http.post(url, data, { headers: headers });
   }
  verifyRazorPaySuccess(data) {
    return this.http.post(this.testRazorPaySuccessUrl,data);
  }
  getLicenseInfo(id) {
    return this.http.get(this.licenseInfoUrl +'/' + id, { headers: headers });
  }
  getpaymentGatewayCount(filter) {
    const payu = this.http.get(this.paymentGatewayUrl +'/'+ 'RAZORPAY' + filter);
    const paytm = this.http.get(this.paymentGatewayUrl +'/'+ 'PAYTM' + filter);
    return forkJoin([payu, paytm]);
      // .map(responses => {
      //   return [].concat(...responses);
      // });
  }


  getAdwords(id) {
    return this.http.get(this.adwordUrl +'/'+ id, { headers: headers });
  }
  deleteAdword(adwordId, id) {
    return this.http.delete(this.adwordUrl +'/'+ adwordId + '/' + id, { headers: headers });
  }
  // changeLicenseSubscription(type, accountId) {
  //   return this.http.put(this.changeLicenseSubscriptionUrl + type + '/' + accountId, { headers: headers });
  // }
   changeLicenseSubscription(type, accountId) {
    return this.http.put(this.accountUrl +'/' + accountId + '/license/billing/' + type, { headers: headers });
  }
  emailUnverify(accountId) {
    const userType = localStorage.getItem('userType');
    if (userType === 'superadmin') {
      return this.http.put(this.emailUnverifyUrl + '/' + accountId, { headers: headers });
    } else {
      return this.http.put(this.support_emailUnverifyUrl + '/' + accountId, { headers: headers });
    }
  }
  getMinimalAccountInfo(accountId) {
    return this.http.get(this.getMinimalInfoUrl + accountId, { headers: headers });

  }

  getPaymentCount(filter): Observable<any> {
    return this.http.get(this.accountPaymentCountUrl + filter, { headers: headers });
  }

  getPaymentList(
    filter, sortOrder,
    pageNumber, pageSize): Observable<any> {

    return this.http.get(this.accountPaymentUrl + filter, {
      params: new HttpParams()
        .set('asc', sortOrder)
        .set('from', pageNumber.toString())
        .set('count', pageSize.toString())
    });
  }
  getLicenseInvoices( filter, sortOrder,
    pageNumber, pageSize ): Observable<any> {
      return this.http.get(this.accountLicenseInvoicesUrl + filter, {
        params: new HttpParams()
        .set('asc', sortOrder)
        .set('from', pageNumber.toString())
        .set('count', pageSize.toString())
      });

  }

  getTotalLicenseInvoiceCount(filter): Observable<any> {
    return this.http.get(this.accountLicenseInvoiceCountUrl + filter, { headers: headers });

  }
  changePrimaryPhone(data): Observable<any> {
    return this.http.put(this.accountChangePrimaryPhoneNo, data, { headers: headers });
  }
  getAccountCount() {
    return this.acc_total_count.asObservable();

  }
  setAccountCount(data) {
    this.acc_total_count.next(data);
  }
  deleteAccounts(filter): Observable<any> {
    return this.http.delete(this.deleteAccountbyCriteria + filter, { headers: headers });
  }
  deleteBranch(filter): Observable<any> {
    return this.http.delete(this.deleteBranchbyCriteria + filter, { headers: headers });
  }
  markAsPaid(data) {
    return this.http.put(this.markaspaidUrl, data, { headers: headers });

  }
  getCorporates() {
    return this.http.get(this.getCorporatesUrl, { headers: headers });
  }
  applyinvoiceDiscount(data) {
    return this.http.put(this.applyinvoicediscountUrl, data, { headers: headers });
  }
  removeOndemandinvoiceDiscount(uuid) {
    return this.http.delete(this.applyinvoicediscountUrl + '/' + uuid , {headers: headers});
  }
   removeProformainvoiceDiscount(data,uuid) {
    return this.http.put(this.applyproformaInvoicediscountUrl + '/removediscount/' + uuid ,data, {headers: headers});
  }
  getPaidInvoiceDetails(uuid): Observable<any> {
    return this.http.get(this.getPaidDetailsUrl +'/'+ uuid, { headers: headers });
  }
  deleteUnclaimedAccounts(filter): Observable<any> {
    return this.http.delete(this.deleteUnclaimedAccountsbyCriteria + filter, { headers: headers });
  }
  getTaxDetails(id): Observable<any> {
   return this.http.get(this.getTaxDetailsUrl  +'/' + id , {headers: headers});
  }
  cancelInvoice(data) {
    return this.http.put(this.cancelinvoiceUrl, data , {headers: headers});
  }

  getSubscriptionDetails(accountId: number): any {
    return this.http.get(this.accountUrl  +'/'+ accountId  + '/license/billing', {headers: headers});
  }
  getnextBillCycle(accountId) {
    return this.http.get(this.accountUrl +'/'+ accountId + '/license/billing/nextBillCycle', { headers: headers });
  }
  revertAddon(accountLicId, accountId) {
    return this.http.put(this.addonUrl +'/'+ accountLicId + '/downgrade' + '/revert' + '/' + accountId, { headers: headers });
  }
  mergeStmt(invoiceRefNumber) {
    // console.log(invoiceRefNumber)
    return this.http.get(this.mergeinvoice +'/' + invoiceRefNumber + '/merge' + '/stmt' , { headers: headers });
  }
  corporatesettings(accountId) {
    // console.log(accountId)
    return this.http.get(this.copset +'/' + accountId + '/corporate', { headers: headers });
  }
  licenseUsage(accountId) {
    return this.http.get(this.licenseUsageInfoUrl +'/' + accountId + '/today' + '/usageInfo', { headers: headers });
  }
  getPaymentHistory( filter, sortOrder,
    pageNumber, pageSize , accountId ): Observable<any> {
      return this.http.get(this.paymentHistoryUrl +'/' + accountId + filter, {
        params: new HttpParams()
        .set('asc', sortOrder)
        .set('from', pageNumber.toString())
        .set('count', pageSize.toString())
      });

  }
  getTotalPaymentHistoryCount(filter , accountId): Observable<any> {
    return this.http.get(this.paymentHistoryCountUrl +'/' + accountId + '/count'+ filter, { headers: headers });

  }
  getmodes(accountId): any {
    return this.http.get(this.VideoModeUrl +'/' + accountId + '/virtualCallingModes', {headers: headers});
  }
  updateZoomid(accountId , data) {
    return this.http.put(this.VideoModeUrl +'/' + accountId + '/virtualCallingModes',data,{ headers: headers});
  }
  getpaymentuuid(uuid): any {
    return this.http.get(this.paymentHistoryuuidUrl +'/' + uuid, {headers: headers});
  }
  getStats(statType,accountId): any {
    // console.log(accountId);
    return this.http.get(this.bookingStatUrl + '/' + statType + '/sp' + '/' + accountId, {headers: headers});
  }
  getpaymentStats(statType,accountId): any {
    // console.log(accountId);
    return this.http.get(this.bookingStatUrl + '/' + statType + '/payment/sp' + '/' + accountId, {headers: headers});
  }
  getdata(){
    return this.http.get(this.getSupportUrl, {headers: headers});
  }
  getLabels(){
    return this.http.get(this.LabelgetUrl, {headers: headers});
  }
  ApplyLabels(formData) {
    return this.http.post(this.ApplyLabelUrl, formData, { headers: headers});
  }
  
  deleteLabels(body?) {
    const options: any = {};
    if (body) {
      options.body = body;
    }
    return this.http.delete(this.DeleteLabelUrl ,options);
  }
  getQuestions(account) {
    return this.http.get(this.questionnaireUrl +'/' + account + '/questionnaire' , { headers: headers });
  }
  changeQuestionStatus(accid,status,qid) {
    return this.http.put(this.questionnaireUrl +'/'+ accid + '/questionnaire/change/' + status + '/'+ qid, { headers: headers });
  }
  SendMessage(filter) {
    return this.http.post(this.sendmsg + filter, { headers: headers });
  }
  SendMessage_nofilter(post_data) {
    return this.http.post(this.sendmsgbyId, post_data, { headers: headers });
  }
  paymentInfocreate(accid,data) {
    return this.http.post(this.paymentDetailsUrl +'/'+ accid,data);
  }
  getPaymentProfiles(accountId) {
    return this.http.get(this.paymentProfilesUrl + '?accountId=' + accountId, { headers: headers });
  }
  updateDefaultPayBank(accountId, data) {
    return this.http.put(this.defaultPayBankUrl + '?accountId=' + accountId, data, { headers: headers });
  }
  getPayBankDetails(accountId) {
    return this.http.get(this.payBankDetailsUrl + '?accountId=' + accountId, { headers: headers });
  }
  getpaymentDetails(accid) {
    return this.http.get(this.paymentDetailsUrl +'/'+ accid, { headers: headers });
  }
  getpaymentBankInfo(accid,bankid){
    return this.http.get(this.paymentDetailsUrl +'/'+ bankid + '/' + accid, { headers: headers });
  }
  paymentInfoupdate(data,accid,bankid){
    return this.http.put(this.paymentDetailsUrl +'/' + bankid + '/' + accid, data , { headers: headers });
  }
  testverifyPayU(id,payprofileid) {
    return this.http.post(this.testPayuUrl +'/' + id + '/' + payprofileid, { headers: headers });
  }
  testverifyRazorPay(id,payprofileid){
    return this.http.post(this.testRazorPayUrl +'/' + id + '/' + payprofileid, { headers: headers });
  }
  getManualstatementsList(filter,sortDirection, count, pageSize){
    return this.http.get(this.accountLicenseInvoicesUrl  + filter, {
      params: new HttpParams()
      .set('asc', sortDirection)
      .set('from', count.toString())
      .set('count', pageSize.toString())
    });
  }
  publishInvoice(uuid) {
    return this.http.put(this.publishinvoiceUrl +'/'+ uuid , {headers: headers});
  }
  testverifyPayTm(id,payprofileid) {
    return this.http.post(this.testPaytmUrl +'/' + id + '/' + payprofileid, { headers: headers });
  }
  uploadAssets() {
    // return this.http();
  }

  getPresignedUrlforPWA(accountId) {
    return this.http.put(this.getPresignedPWAUrl +'/' + accountId, { headers: headers });
  }

  extractPWAFiles(accountId) {
    const url = this.getPresignedPWAUrl +'/' + "extract/assets/" + accountId;
    return this.http.get(url);
  }
  uploadPWAFiles(url, file) {
    console.log(url);
    // return this.http.put(this.getPresignedPWAUrl + '46805', { headers: headers });
    console.log(file);
    return this.http.put(url, file);
  }
   paymentSettlement(gatewayTransactionid,settlementUtr) {
    return this.http.put(this.paymentSettlementUrl +'/' +  gatewayTransactionid + '/UTR/'+  settlementUtr , { headers: headers });
  }
  // getQuestions( filter, sortOrder,
  //   pageNumber, pageSize , accountId ): Observable<any> {
  //     console.log(accountId)
  //     return this.http.get(this.questionListUrl  + accountId + '/questionnaire' +filter, {
  //       params: new HttpParams()
  //       .set('asc', sortOrder)
  //       .set('from', pageNumber.toString())
  //       .set('count', pageSize.toString())
  //     });

  // }

  getAnalyticsMetricsList() {
    const url = this.analyticsUrl + "/list";
    return this.http.get(url);
  }

  getAnalytics(source, filter){
    const url = this.analyticsUrl + "/" + source + '?' + filter;
    return this.http.get(url);
  }

  storeAnalyticsInfo(data) {
    this.analyticsInfo = data;
  }
  /**Account analytics by sector  */
   
  // communicatefilter(msg){
  //   this.filterdata=1;  //i added ---------------
  // }

  getAccountAnalyticsBySector(sector,filterparams): Observable<any> {

    return this.http.get(this.accountAnalyticsBySectorUrl +'/' + sector + filterparams, { headers: headers });
  }

  changeJaldeeHomeo(id,channel ,data) {
    return this.http.put(this.jaldeeHomeoUrl + "/" + id + "/" + channel,data, { headers: headers });
  }
  getChannels() {
    return this.http.get(this.channelsUrl, { headers: headers });
  }
  changestatementGeneration(accountId,stmtCreatedBySystem) {
    return this.http.put(this.changestatementGenerationUrl +'/' + accountId + '/' + stmtCreatedBySystem , { headers: headers });
  }
  noteUpdate(data){
    return this.http.put(this.noteUrl ,data ,{headers: headers});
   }
   getAddress(accountId) {
    return this.http.get(this.addonUrl + '/address/' + accountId, { headers: headers });
  }
 
  getTemplateDetailsById(accId,templatedetailId) {
    return this.http.get(this.sectionListUrl +'/' + accId + '/' + templatedetailId , { headers: headers });
  }
  createTemplate(accId,post_data){
    return this.http.post(this.sectionUrl  +'/' + accId,post_data, { headers: headers });
  }
  updateTemplate(accId,id,post_data){
    return this.http.put(this.sectionUrl +'/' + accId + '/' +  id, post_data, { headers: headers });
  }
  getTemplates(accId) {
    return this.http.get(this.sectionUrl +'/' + accId , { headers: headers });
  }
  deleteTemplate(accountId, temId) {
    return this.http.delete(this.sectionUrl +'/' + accountId + '/' + temId, { headers: headers });
  }
  getSectionDetails(accId,templatedetailId) {
    return this.http.get(this.sectionListUrl +'/' + accId + '?template-eq=' + templatedetailId , { headers: headers });
  }
  createDetails(accId,post_data){
    return this.http.post(this.sectionListUrl  +'/' + accId ,post_data, { headers: headers });
  }
  updateDetails(accId,tempDetailId,post_data){
    return this.http.put(this.sectionListUrl +'/'  + accId + '/' + tempDetailId,post_data, { headers: headers });
  }
  getData(accId) {
    return this.http.get(this.accountUrl +'/'+ accId + '/app/register' , { headers: headers });
  }
  registerApp(accId,post_data){
    return this.http.post(this.accountUrl +'/' + accId + '/app/register' ,post_data, { headers: headers });
  }
  getDataMigrationList( filter, sortOrder,
    pageNumber, pageSize , accountId ): Observable<any> {
      return this.http.get(this.migrationUrl +'/' + accountId + '/list' + filter, {
        params: new HttpParams()
        .set('asc', sortOrder)
        .set('from', pageNumber.toString())
        .set('count', pageSize.toString())
      });

  }
  getTotalMigrationDataCount(filter , accountId): Observable<any> {
    return this.http.get(this.migrationUrl +'/'+ accountId + '/count'+ filter, { headers: headers });

  }
  generateOtp(accountId, idFormat, uid,data){
    return this.http.post(this.migrationUrl +'/' + accountId + '/' + idFormat + '/Patients/migrate/' + uid + '/generateotp', data , { headers: headers });
  }
  dataMigrate(accountId, idFormat, uid,otp, data){
    return this.http.post(this.migrationUrl  +'/'+ accountId + '/' + idFormat + '/Patients/migrate/' + uid + '/verifyotp/'  + otp, data, { headers: headers });
  }
  generateOtpForLeads(accountId, uid){
    return this.http.post(this.migrationUrl +'/' + accountId + '/CrmLeads/migrate/' + uid + '/generateotp' , { headers: headers });
  }
  dataMigrateForLeads(accountId, uid,otp){
    return this.http.post(this.migrationUrl  +'/'+ accountId + '/CrmLeads/migrate/' + uid + '/verifyotp/'  + otp, { headers: headers });
  }
  generateOtpForcatelog(accountId, catEncId, uid){
    return this.http.post(this.migrationUrl +'/' + accountId + '/catalog/' + catEncId + '/items/migrate/' + uid + '/generateotp' , { headers: headers });
  }
  dataMigrateForcatelog(accountId, catEncId, uid,otp){
    return this.http.post(this.migrationUrl +'/' + accountId + '/catalog/' + catEncId + '/items/migrate/' + uid + '/verifyotp/'  + otp, { headers: headers });
  }
  generateOtpForinvcatelog(accountId, catEncId, uid){
    return this.http.post(this.migrationUrl +'/' + accountId + '/inventorycatalog/' + catEncId + '/items/migrate/' + uid + '/generateotp' , { headers: headers });
  }
  dataMigrateForinvcatelog(accountId, catEncId, uid,otp){
    return this.http.post(this.migrationUrl  +'/' + accountId + '/inventorycatalog/' + catEncId + '/items/migrate/' + uid + '/verifyotp/'  + otp, { headers: headers });
  }
  generateOtpForstockAdjust(accountId, catEncId, uid){
    return this.http.post(this.migrationUrl +'/' + accountId + '/remarks/' + catEncId + '/StockAdjust/migrate/' + uid + '/generateotp' , { headers: headers });
  }
  dataMigrateForstockAdjust(accountId, catEncId, uid,otp){
    return this.http.post(this.migrationUrl  +'/'+ accountId + '/remarks/' + catEncId + '/StockAdjust/migrate/' + uid + '/verifyotp/'  + otp, { headers: headers });
  }
  generateOtp_Appt(accountId, migrationTo, uid,data){
    return this.http.post(this.migrationUrl  +'/'+ accountId + '/' + migrationTo + '/migrate/' + uid + '/generateotp' , data,{ headers: headers });
  }
  dataMigrate_Appt(accountId, migrationTo, uid,otp,data){
    return this.http.post(this.migrationUrl  +'/'+ accountId + '/' + migrationTo + '/migrate/' + uid + '/verifyotp/'  + otp,data, { headers: headers });
  }
  generateOtp_noteSorAppt(accountId, migrationTo, uid){
    return this.http.post(this.migrationUrl +'/'  + accountId + '/' + migrationTo + '/migrate/' + uid + '/generateotp' , { headers: headers });
  }
  dataMigrate_noteSorAppt(accountId, migrationTo, uid,otp){
    return this.http.post(this.migrationUrl  +'/'+ accountId + '/' + migrationTo + '/migrate/' + uid + '/verifyotp/'  + otp, { headers: headers });
  }
  generateOtpForRevert(accountId, uid){
    return this.http.delete(this.migrationUrl +'/' + accountId + '/revert/' + uid + '/generateotp', { headers: headers });
  }
  dataRevert(accountId,uid,otp){
    return this.http.delete(this.migrationUrl  +'/'+ accountId + '/revert/' + uid + '/verifyotp/' + otp, { headers: headers });
  }
  getFileDetails(accId,uid) {
    return this.http.get(this.migrationUrl +'/'+ accId + '/' + uid , { headers: headers });
  }
  getConsentFormList(accId) {
    return this.http.get(this.consentFormUrl +'/'+ accId, { headers: headers });
  }
  changeFormSettings(accid,status) {
    return this.http.put(this.updateSettingsUrl +'/' + accid + '/consentform/' + status, { headers: headers });
  }
  createConsentForm(accid,data) {
    return this.http.post(this.consentFormUrl +'/'+ accid + '/settings', data,{ headers: headers });
  }
  getFormDetailsById(accId,id) {
    return this.http.get(this.consentFormUrl +'/'+ accId + '/settings/' + id , { headers: headers });
  }
  updateConsentForm(accid,data) {
    return this.http.patch(this.consentFormUrl +'/' + accid + '/settings', data,{ headers: headers });
  }
  changeConsentFormSttatus(accid,settingId,status) {
    return this.http.patch(this.consentFormUrl +'/' + accid + '/settings/' + settingId + '/status/' + status,{ headers: headers });
  }
  markasnotPaid(id) {
    return this.http.put(this.invoiceUrl + '/' +  id , {headers: headers});
  }
  getCatelog(id) {
    return this.http.get(this.migrationUrl +'/' + id + '/so/catalog', { headers: headers });
  }
  export_SpItems(data,id) {
    return this.http.put(this.exportUrl +'/' + id +'/export/SPITEMS', data,{ headers: headers });
  }
  export_invItem(data,id) {
    return this.http.put(this.exportUrl +'/' + id +'/export/INVCATALOGITEM', data,{ headers: headers });
  }
  getinventorycatalog(id) {
    return this.http.get(this.migrationUrl +'/' + id + '/inventory/catalog', { headers: headers });
  }
  getremarks(id) {
    return this.http.get(this.migrationUrl +'/' + id + '/inventory/remarks', { headers: headers });
  }
}

